const BOT_UA_PATTERN =
  /bot|crawl|spider|slurp|facebookexternalhit|bingpreview|googlebot|yandex|baiduspider|duckduckbot|semrush|ahref|mj12bot|dotbot|petalbot|bytespider|gptbot|claudebot|ccbot|applebot|twitterbot|linkedinbot|whatsapp|telegrambot|discordbot|pingdom|uptimerobot|headlesschrome|phantomjs|selenium|datadogsynthetics/i;

export function isBotUserAgent(userAgent?: string): boolean {
  const ua = userAgent ?? (typeof navigator !== 'undefined' ? navigator.userAgent : '');
  if (!ua) {
    return false;
  }
  return BOT_UA_PATTERN.test(ua);
}
